export interface CheckCanAccessDiscoverMoreParams {
  PAY_4551_DISCOVER_MORE_PAGE?: boolean
}

export class CheckCanAccessDiscoverMoreUseCase {
  execute = ({
    PAY_4551_DISCOVER_MORE_PAGE,
  }: CheckCanAccessDiscoverMoreParams): boolean =>
    PAY_4551_DISCOVER_MORE_PAGE === true
}
